import axios from 'axios';

import ActivityLogSearchRequest from '../types/ActivityLogSearchRequest';

const url = '/candidatesearch/api/';
export const getCandidateActivityLogs = (payload: ActivityLogSearchRequest) =>
  axios.post(`${url}activity-log/search`, payload);

export const getCandidateAuditLogs = (id: string) => axios.get(`${url}audit-log/${id}`);

export const getAuditLogsById = (id: string) => axios.get(`${url}audit-log/id/${id}`);

export const getAllAuditLogByCandidateid = (id: string) => axios.get(`${url}audit-log/all/${id}`);
